import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  padding-top: 60px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 2.5rem;
  font-weight: 800;
  font-family: 'Public Sans', sans-serif;
  color: #002E3B;
  margin-bottom: 16px;
  .material-symbols-outlined {
    font-size: 48px;
    color: inherit;
  }
`;

const StepsContainer = styled.div`
  display: flex;
  gap: 1px;
  justify-content: center;
  align-items: center;
`;

const StepCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #FFCC85;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  font-weight: bold;
  background-color: ${({ $isCurrent, $isCompleted }) =>
    $isCurrent ? '#FF9F1F' : $isCompleted ? '#FF9F1F' : '#FFFFFF'};
`;

const StepLine = styled.div`
  width: 50px;
  height: 4px;
  background-color: #FF9F1F;
`;

const RegisterProgress = ({ step = 1, title = '', icon }) => {
  const steps = [1, 2, 3, 4, 5, 6];

  return (
    <Wrapper>
      {(title || icon) && (
        <TitleWrapper>
          {icon && <span className="material-symbols-outlined">{icon}</span>}
          {title}
        </TitleWrapper>
      )}
      <StepsContainer>
        {steps.map((s, index) => (
          <React.Fragment key={s}>
            <StepCircle $isCurrent={s === step} $isCompleted={s < step}>
              {s}
            </StepCircle>
            {index < steps.length - 1 && <StepLine />}
          </React.Fragment>
        ))}
      </StepsContainer>
    </Wrapper>
  );
};

export default RegisterProgress;


